import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';
import { RouterLink } from '@angular/router';

import { SafeHtmlPipe } from '../../pipes/safe-html.pipe';

import { BreakpointService } from '../../../core/services/breakpoint.service';

@Component({
  selector: 'app-text-ellipsis',
  templateUrl: 'text-ellipsis.component.html',
  styleUrls: ['./text-ellipsis.component.scss'],
  imports: [SafeHtmlPipe, RouterLink],
})
export class TextEllipsisComponent {
  @Input() isSmallText: boolean = false;
  @Input() short: string = '';
  @Input() long: string = '';
  @Input() extra: string = '';
  @Input() text: string = '';
  @Input() thingsToDoShort: string = '';
  @Input() thingsToDoCity: string = '';
  @Input() scrollContainerClass = 'mobile-planner__services-info';
  @ViewChild('textEllipsis') textEllipsis!: ElementRef<HTMLDivElement>;

  isExpanded: boolean = false;

  constructor(
    private cdr: ChangeDetectorRef,
    protected breakpointService: BreakpointService,
  ) {}

  public getThingsTodoLink(name: string): string {
    return `/things-to-do-in-${name.toLowerCase()}`;
  }

  toggleText(event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }

    this.isExpanded = !this.isExpanded;
    this.cdr.markForCheck();

    if (!this.isExpanded) {
      const element = this.textEllipsis.nativeElement;
      window.scrollTo({
        top: element.getBoundingClientRect().top - 200,
        behavior: 'smooth',
      });
    }
  }
}
